import { useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogTrigger } from "@/components/ui/dialog";
import { Building2 } from "lucide-react";
import { toast } from "sonner";

export function CompanyDialog({ onSaved }) {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const [open, setOpen] = useState(false);
  const [c, setC] = useState(null);

  useEffect(() => { if (open) api.get("/company").then((r) => setC(r.data)).catch((e) => toast.error(errMsg(e))); }, [open]);

  const save = async (e) => {
    e.preventDefault();
    try {
      const r = await api.put("/company", c);
      toast.success("Company details saved"); setOpen(false); onSaved && onSaved(r.data);
    } catch (err) { toast.error(errMsg(err)); }
  };
  const f = (key, label, props = {}) => (
    <div className="space-y-2"><Label>{label}</Label>
      <Input data-testid={`company-dialog-${key}`} value={c[key] || ""} onChange={(e) => setC({ ...c, [key]: key === "gstin" ? e.target.value.toUpperCase() : e.target.value })} disabled={!isAdmin} {...props} /></div>
  );

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" data-testid="my-company-btn" className="gap-2 border-border"><Building2 className="h-4 w-4" /> My Company</Button>
      </DialogTrigger>
      <DialogContent className="bg-card border-border max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogHeader><DialogTitle>My Company (Bill By / Raised By)</DialogTitle></DialogHeader>
        {c && (
          <form onSubmit={save} className="space-y-4">
            {f("name", "Company Name", { required: true })}
            {f("address", "Address")}
            <div className="grid grid-cols-2 gap-4">
              {f("state", "State (for CGST/SGST vs IGST)", { placeholder: "Uttar Pradesh" })}
              {f("gstin", "GSTIN", { maxLength: 15 })}
            </div>
            <div className="grid grid-cols-2 gap-4">
              {f("phone", "Phone")}
              {f("email", "Email")}
            </div>
            <div className="space-y-2"><Label>Bank Details</Label>
              <Textarea data-testid="company-dialog-bank" rows={3} value={c.bank_details || ""} onChange={(e) => setC({ ...c, bank_details: e.target.value })} disabled={!isAdmin} placeholder="Bank, A/c No, IFSC" /></div>
            <div className="space-y-2"><Label>Terms / Footer Note</Label>
              <Textarea data-testid="company-dialog-terms" rows={2} value={c.terms || ""} onChange={(e) => setC({ ...c, terms: e.target.value })} disabled={!isAdmin} /></div>
            {isAdmin ? <DialogFooter><Button type="submit" data-testid="company-dialog-save" className="bg-sky-500 hover:bg-sky-600 text-white">Save Company</Button></DialogFooter>
              : <p className="text-xs text-muted-foreground">Only admin can edit company details.</p>}
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}
